module.exports = __webpack_public_path__ + "static/img/071.2df98f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/071.png
// module id = Uuba
// module chunks = 0